export const MAX_INPUT_LENGTH = 100;

export const MAX_LETTERS_LIMITATION = 255;
